export const translation = {
  navigateToPaymentMethods: 'Show other ways to pay',
  payWithCard: 'Or pay with card',
  cardNumber: 'Card number',
  cardExpiry: 'Expiry (MM/YY)',
  cardExpiryPlaceholder: 'MM/YY',
  cardCVV: 'CVV',
  cardholderName: 'Name on card',
  cardholderNamePlaceholder: 'Full name',
  digits: 'digits',
  previouslyUsed: 'Previously used:',
  forgetPaymentMethods: 'Forget payment methods',
  forgetSavedCard: 'Forget saved card ending in {{last4Digits}}',
  required: 'Required',
  invalid: 'Invalid',
  cardInvalid: 'Card number is invalid',
  expiryInvalid: 'Expiry date is invalid',
  expiryMonthInvalid: 'Expiry date month is invalid',
  expiryYearInvalid: 'Expiry date year is invalid',
  cardExpired: 'Card has expired',
  cardIncomplete: 'Card number is incomplete',
  expiryIncomplete: 'Expiry date is incomplete',
  cvvIncomplete: 'CVV number is incomplete',
  cvvInvalid3: 'CVV must be 3 digits',
  cvvInvalid4: 'CVV must be 4 digits',
  cardRequired: 'Card number is required',
  expiryRequired: 'Expiry date is required',
  cvvRequired: 'CVV number is required',
  cardNameRequired: 'Name on card is required',
  forgetPayPal: 'Forget PayPal account',
  savePaymentMethod: 'Save payment method',
  managePaymentMethods: 'Manage your payment methods',
  savedPaymentMethodsEmpty:
    'Enter your card details below to add a new payment method',
  newPaymentMethod: 'Add a new payment method',
  cardEndingWith: 'Card ending with',
  accountHolderName: 'Account holder name',
  pay: 'Pay',
  addCard: 'Add Card',
  confirm: 'Confirm',
  directDebitSmallPrint: `By signing this mandate form, you authorise (A) {{companyName}} to send instructions to your bank to debit your account and (B) your bank to debit your account in accordance with the instruction from {{companyName}}`,
  otherWaysToPay: 'Other ways to pay',
  // Payment methods dropdown
  editPaymentMethods: 'Edit saved payment methods',
  confirmCardDeletion: 'Confirm - Delete Card',
  confirmPayPalDeletion: 'Confirm - Delete PayPal',
  delete: 'Delete',
  cancel: 'Cancel',
  // Direct Debit Form
  accountHolder: 'Account Holder',
  address: 'Address',
  addressLine1: 'Address line 1',
  addressLine2: 'Address line 2',
  fullName: 'First and last name',
  email: 'Email',
  city: 'City',
  postalCode: 'Postal code',
  setUpDirectDebit: 'Set up Direct Debit',
  unsupportedCardType: 'Unsupported card type',
  // Direct Debit success
  directDebitSuccessTitle: 'Direct Debit set up successfully',
  directDebitSuccessDescription: `{{companyName}} will appear on your bank statement when payments are taken against the Direct Debit`,
  directDebitSuccessReference: 'Reference',
  // Direct Debit Mandate
  directDebitMandateTitle: 'SEPA Core Direct Debit Mandate',
  // Success scene
  checkSuccessTitle: 'Your payment was successful!',
  // Error
  tokenizationError:
    'Your payment could not be processed. Please try another payment method.',
  duplicatePaymentMethodError: 'This payment method is already saved.',
  // Payment Method Popup Overlay
  paymentMethodPopupOverlayClose: 'Close',
  paymentMethodPopupOverlayDescription:
    "Having trouble viewing the {{paymentMethodName}} payment page? We'll help you find it!",
  paymentMethodPopupOverlayBringBackThePaymentPage:
    'Bring back the payment page',
};
